import React from 'react';
import { cn } from '#/utils/styles';

export interface PanelProps extends React.ComponentProps<'div'> {
  direction: 'left' | 'right';
}

/**
 * A panel component that can be used to create a panel in the dashboard.
 */
function Panel({
  children,
  className,
  direction,
  ...props
}: React.PropsWithChildren<PanelProps>) {
  return (
    <div
      className={cn(
        'w-full h-full relative border-divider bg-background-default',
        {
          'border-r': direction === 'left',
          'border-l': direction === 'right',
        },
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export default Panel;
